import { z } from 'zod';
import { Validator } from '@leverege/validator';
const phoneValidator = Validator.optional(Validator.isPhone);
export default {
  createFor(name, objectType, {
    isArray = false,
    molten
  }) {
    molten.addPlugin('AttributeValueValidator', {
      name,
      objectType,
      valueValidator: isArray ? z.array(z.custom(phoneValidator)).optional().nullable() : z.custom(phoneValidator).optional().nullable()
    });
  }
};